/** Signature of a logging function */
type LogFn = (message?: any, ...optionalParams: any[]) => void;

/** Basic logger interface */
interface Logger {
  log: LogFn;
  warn: LogFn;
  error: LogFn;
}

/** Logger which outputs to the browser console */
const ConsoleLogger: Logger = {
  log: (message?: any, ...optionalParams: any[]): void => {
    console.log(message, ...optionalParams);
  },

  warn: (message?: any, ...optionalParams: any[]): void => {
    console.warn(message, ...optionalParams);
  },

  error: (message?: any, ...optionalParams: any[]): void => {
    console.error(message, ...optionalParams);
  }
};

export default ConsoleLogger;